import { isBefore } from "date-fns";

export function chartingDeadlineHasPassed(deadlineToChart: Date) {
  return isBefore(deadlineToChart, new Date());
}
